import React, { useContext } from 'react';
import classnames from 'classnames';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ConditionalWrapper from '@wix/da-ds/pkg/ConditionalWrapper';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
import DefaultPopoverContent from '@wix/da-ds/pkg/popper/_partials/DefaultPopoverContent';
import TextTooltipContent from '../../_partials/TextTooltipContent';
import PopperPositionedPopover from '@wix/da-ds/pkg/popper/PopperPositionedPopover';
import s from './TextTooltipOnHover.scss';
const defaultOffsetModifier = [
    0,
    6
];
/** @deprecated */ const TextTooltipOnHover = ({ title, tooltipText, className, textClassName, contentClassName, wrapperClassName, listenOnClicks, forceTheme, width, noMinWidth, children, placement, secondaryPlacement, oneLine, onHide, renderReference, referenceElement, positionFixed, eventsEnabled, isVisible: isVisibleProp = true, // Design indicates popovers should be separated 8px away from their reference point.
// Since most icon boxes and/or text have some amount of blank space around them, setting
// the default popover offset to 6px seems to achieve a look pretty close to spec in general.
// In other cases it can be overriden if it really needs fixing.
offsetModifier = defaultOffsetModifier, hoverDelay })=>{
    const isMobile = useContext(MobileContext);
    const { isVisible, onClick, onMouseEnter, onMouseLeave } = usePopoverOnInteraction({
        listenOnClicks,
        listenOnHover: !isMobile,
        onHide,
        hoverDelay
    });
    if (!tooltipText && !title) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, {
        isVisible: isVisible && isVisibleProp,
        offsetModifier: offsetModifier,
        eventsEnabled: eventsEnabled && isVisible,
        positionFixed: positionFixed,
        referenceElement: referenceElement,
        renderReference: renderReference,
        usePortal: true,
        className: classnames(s['children-wrapper'], className),
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        disablePlacementModifier: true,
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave,
        renderPopover: ({ effectivePlacement, effectiveSecondaryPlacement, contentStyle, arrowStyle, contentAttributes, arrowAttributes, rootRef, arrowRef, updatePositioning })=>/*#__PURE__*/ React.createElement(ConditionalWrapper, {
                condition: !!forceTheme,
                wrap: (child)=>/*#__PURE__*/ React.createElement(ThemeOverride, {
                        theme: forceTheme
                    }, child)
            }, /*#__PURE__*/ React.createElement(DefaultPopoverContent, {
                effectivePlacement: effectivePlacement,
                effectiveSecondaryPlacement: effectiveSecondaryPlacement,
                rootRef: rootRef,
                arrowRef: arrowRef,
                contentStyle: contentStyle,
                arrowStyle: arrowStyle,
                contentAttributes: contentAttributes,
                arrowAttributes: arrowAttributes,
                showArrow: true,
                updatePositioning: updatePositioning,
                wrapperClassName: classnames(s['root'], isVisible && s['visible'], wrapperClassName),
                contentClassName: classnames(s['content-classname'], contentClassName),
                oneLine: oneLine,
                width: width,
                noMinWidth: noMinWidth,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            }, /*#__PURE__*/ React.createElement(TextTooltipContent, {
                title: title,
                tooltipText: tooltipText,
                textClassName: textClassName
            })))
    }, children);
};
TextTooltipOnHover.displayName = 'TextTooltipOnHover';
export default TextTooltipOnHover;

//# sourceMappingURL=TextTooltipOnHover.js.map